import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ScheduleSlotButton } from '@/components/ui/schedule-slot-button.component';
import { Button } from '@/components/ui/button/button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { ScheduleSlotsDay } from '@/app/(main)/(pages)/_components/schedules/_hooks/use-schedule-slots.hook';
import { SchedulesSearchSlot } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { dateFormatter } from '@/utils/formatters/date';
import { formatRelativeDay } from '@/utils/formatters/format-relative-day';
import { cn } from '@/utils/cn-tw-merge';

const PREVIEW_SLOT_COUNT = 3;

interface ScheduledTabPreviewProps {
  day: ScheduleSlotsDay | undefined;
  markedSlotIds: ReadonlySet<string>;
  busySlotIds: ReadonlySet<string>;
  className?: string;
  onSeeMore: () => void;
  onSelectSlot: (slot: SchedulesSearchSlot) => void;
}

export function ScheduledTabPreview({
  day,
  markedSlotIds,
  busySlotIds,
  className,
  onSeeMore,
  onSelectSlot,
}: ScheduledTabPreviewProps) {
  const previewSlots = day?.slots.slice(0, PREVIEW_SLOT_COUNT) ?? [];

  return (
    <div
      className={cn('flex flex-col gap-2', className)}
      data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_SCHEDULED_PREVIEW}
    >
      {day && (
        <Typography variant={TypographyVariant.MEDIUM_BODY_TEXT} className="font-semibold">
          {`Próximos horários: ${formatRelativeDay(day.date)}`}
        </Typography>
      )}
      {previewSlots.length > 0 && (
        <div className="flex flex-wrap gap-2 w-full">
          {previewSlots.map((slot) => (
            <ScheduleSlotButton
              key={slot.id}
              start={dateFormatter(slot.start, 'HH:mm')}
              selected={markedSlotIds.has(slot.id)}
              busy={busySlotIds.has(slot.id)}
              className="flex-1 basis-0 min-w-[80px]"
              onClick={() => onSelectSlot(slot)}
            />
          ))}
        </div>
      )}
      <Button
        variant="default"
        className="w-full h-10 py-0 text-base"
        data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_SCHEDULED_OPEN_MODAL}
        onClick={onSeeMore}
      >
        Ver mais horários
      </Button>
    </div>
  );
}
